module.exports = __webpack_public_path__ + "img/action-link.20a53ea3.svg";